const pages = {
  // Properties page
  'props.sectionLabel': '販売中物件',
  'props.title': '販売中物件一覧',
  'props.intro': '現在販売中の日本の物件をご覧ください。毎週新しい物件を追加しています。',
  'props.noResults': '該当する物件がありません。',
  'props.propertyNotFound': '物件が見つかりません。',

  // Property detail
  'detail.breadcrumbHomes': '物件一覧',
  'detail.opportunity': '物件の魅力',
  'detail.specifications': '物件概要',
  'detail.renovationPlan': 'リノベーション計画',
  'detail.indicativeReturn': 'トータル投資額・収益試算',
  'detail.area': '周辺環境',
  'detail.mapPlaceholder': 'お問い合わせ後に地図を表示',
  'detail.buyTogether': '共同保有で購入',
  'detail.buyTogetherDesc': '共同保有マッチングにより、少人数で自分の名義でこの物件を購入できます。各所有者は登記された持分（持分）を保有します。NORENは共同保有者候補の紹介と取引仲介を行います。条件は各自の法律顧問と独自の契約書で定めます。',
  'detail.offMarketNotice': 'ご確認ください：',
  'detail.offMarketNoticeText': '価格、面積、販売状況はお問い合わせ時に確認します。詳細資料、内覧、リノベーション見積もりについてはお気軽にご連絡ください。',
  'detail.cgCaption': '最初の{{cgCount}}枚{{cgCountParticle}}リノベーションCG（完成予想図）です。残りの{{currentCount}}枚は現状写真です。',
  'detail.unknownSpec': '— {{field}}を入力',
  'detail.disclaimer': 'すべての試算は保守的なモデリングに基づく参考値です。実際の費用・収益はリノベーション範囲、市場状況、規制対応により異なります。物件ごとに個別モデリングを行っています。',

  // Co-ownership page
  'co.pageLabel': '共同保有マッチング',
  'co.pageTitle': '一緒に買う。',
  'co.pageTitleItalic': '名義は自分。分け合うのはコスト。',
  'co.pageIntro': 'NORENは、共同購入に適した物件について、審査済みの共同保有者をご紹介します。各所有者は自分の名義で直接持分を取得します。NORENは資金の集約・運用・収益保証は行いません。',
  'co.legalBannerTitle': '仕組みについて：',
  'co.legalBannerText': 'NORENはマッチングボードおよび宅地建物取引業者に過ぎません。共同保有者候補の紹介と不動産取引の仲介を行います。NORENは資金の集約・保管、投資運用、収益分配は一切行いません。共同保有者は各自の名義で持分を取得し（持分）、弁護士・税理士等と独自の契約書を締結してすべての条件を定め、リスク・紛争も各自で負います。すべての共同保有者は事前に独立した法的・税務アドバイスを受ける必要があります。',
  'co.filterAll': 'すべて',
  'co.filterOpen': '募集中',
  'co.filterAlmost': '残りわずか',
  'co.filterKominka': '古民家',
  'co.noCampaigns': '該当する案件がありません。',
  'co.buyingInto': 'どんな物件に投資するか',
  'co.proposedSplit': '分配案',
  'co.stepsTitle': 'マッチング → 契約 → 購入 → 登記 → 運営',
  'co.risksTitle': 'リスク・開示事項',
  'co.sidebarShare': '1口あたり概算',
  'co.sidebarAllIn': '{{allIn}} ÷ {{count}}名',
  'co.sidebarFilled': '{{wanted}}口中 {{filled}}口確定',
  'co.step1': '01',
  'co.step1Title': 'マッチング',
  'co.step1Desc': 'NORENが予算・意向審査を通過した共同保有者候補をご紹介します。NORENは資金を預かりません。',
  'co.step2': '02',
  'co.step2Title': '契約',
  'co.step2Desc': '共同保有者間で、弁護士・税理士等を交えて共同保有契約書を締結します。条件は所有者間の私的な合意です。',
  'co.step3': '03',
  'co.step3Title': '購入',
  'co.step3Desc': '各共同保有者は自分の名義で直接持分（持分）を購入します。NORENは宅建業者として取引を仲介します。',
  'co.step4': '04',
  'co.step4Title': '登記',
  'co.step4Desc': '法務局で所有権登記を行い、各所有者の持分を記録します。書類作成はNORENがサポートします。',
  'co.step5': '05',
  'co.step5Title': '運営（任意）',
  'co.step5Desc': 'リノベーション・備品・賃貸運営はNORENまたは第三者に依頼可能。収益・費用は所有者に直接流れます。',
  'co.guardrailSidebar': 'ガードレール：',
  'co.guardrailSidebarText': 'NORENは資金の預かり、物件運営、収益保証は行いません。共同保有者はすべてのリスクを負い、独立した法的・税務アドバイスを受ける必要があります。',

  // Contact page
  'contact.sectionLabel': 'お問い合わせ',
  'contact.title': 'お問い合わせ',
  'contact.intro': '予算、目的、タイムラインをお聞かせください。販売中の物件から厳選ショートリストをお送りします。',
  'contact.firstName': '名',
  'contact.lastName': '姓',
  'contact.email': 'メールアドレス',
  'contact.country': '居住国',
  'contact.budget': '予算帯（円）',
  'contact.goal': 'ご希望を教えてください',
  'contact.message': 'メッセージ（任意）',
  'contact.messagePlaceholder': 'タイムライン、希望エリア、質問などをお書きください...',
  'contact.privacy': '個人情報は一切共有しません。通常の返信時間：48時間以内。',

  // About page
  'about.storyLabel': '私たちのストーリー',
  'about.storyTitle': '私たちは、かつてのあなたでした。',
  'about.storyP1': 'NORENは、自力で日本の地方不動産を購入しようとした海外の買い主たちによって設立されました。悪質な調査、契約書の誤読、不適切な業者への発注、民泊法の壁—私たちもすべて経験しました。',
  'about.storyP2': 'NORENは、私たちが理想とするサービスを形にしました。日本語ができなくても、現地に来なくても、探査・購入・リノベーション・許認可・運営まで一貫して英語で完結する、バイリンガルのエンドツーエンドパートナーです。',
  'about.storyP3': '私たちは宅建業の免許を持っていますが、従来の業者とは異なります。悪い物件は買わないようお客様を止めます。見栄えのいい例ではなく、実際の稼働率データを共有します。透明なマージンで、すべての領収書をお見せします。',
  'about.locationLabel': '長野市、日本',
  'about.valuesLabel': '私たちの信念',
  'about.value1Title': '徹底した正直さ',
  'about.value1Body': '投資として不向きな物件は正直にお伝えします。実際の稼働率、維持費、保守的な収益試算を共有します。売り込むより、お客様を信頼でつなぎたいと考えています。',
  'about.value2Title': 'エンドツーエンドの所有',
  'about.value2Body': '購入後にお客様を見捨てません。リノベーション、許認可、掲載、ゲスト対応、月次P&Lレポート—すべて英語で対応します。資産はあなたのもの。運営は私たちが。',
  'about.value3Title': '現地に来る必要なし',
  'about.value3Body': 'すべての書類は翻訳済み。すべての通話には通訳付き。すべての調査には英語解説付き動画。日本に1度も来なくても、日本の不動産を所有・運営できます。',
  'about.statsProps': '管理物件数',
  'about.statsPrefs': '活動都道府県',
  'about.statsSupport': '英語対応',
  'about.statsFees': '隠れた手数料',
  'about.teamLabel': 'チーム',
  'about.teamTitle': '小規模チーム、深い専門性',
  'about.teamDesc': 'コアチームは長野市を拠点とし、東京・横浜・埼玉にパートナーがいます。宅建業者、リノベーション管理、民泊運営の各免許を持ち、すべての物件はチームメンバーが現地調査しています。',
  'about.roleSourcing': '探査・購入',
  'about.roleSourcingDesc': '販売中物件の交渉からクロージングまで、免許を持つ仲介人が対応。',
  'about.roleReno': 'リノベーション',
  'about.roleRenoDesc': '社内デザイナーと審査済み地元業者が6県で施工管理。',
  'about.roleOps': '運営',
  'about.roleOpsDesc': 'ゲスト対応、清掃手配、月次レポート作成。',
  'about.ctaTitle': '詳しく知りたいですか？',
  'about.ctaDesc': '実績の共有、料金体系の説明、実際のケーススタディの紹介—喜んでお手伝いします。',

  // How it works page
  'hiw.sectionLabel': '購入の流れ',
  'hiw.title': '初回面談から賃貸稼働物件になるまで、6ステップ。',
  'hiw.intro': 'すべてのステップは英語で対応。日本に来る必要も、日本語を話す必要もありません。書類、業者、許認可、ゲスト対応はすべて私たちが担当します。',
  'hiw.timelineLabel': '標準的なタイムライン',
  'hiw.phaseMatch': 'マッチング',
  'hiw.phaseMatchWeeks': '第1～2週',
  'hiw.phaseMatchDesc': 'ショートリスト作成',
  'hiw.phaseInspect': '調査',
  'hiw.phaseInspectWeeks': '第2～3週',
  'hiw.phaseInspectDesc': '構造レビュー',
  'hiw.phasePurchase': '購入',
  'hiw.phasePurchaseWeeks': '第4～8週',
  'hiw.phasePurchaseDesc': '契約・決済',
  'hiw.phaseRenovate': 'リノベーション',
  'hiw.phaseRenovateWeeks': '第9～24週',
  'hiw.phaseRenovateDesc': '標準8～16週間',
  'hiw.phaseLaunch': 'スタート',
  'hiw.phaseLaunchWeeks': '第25～28週',
  'hiw.phaseLaunchDesc': '許認可・掲載',
  'hiw.phaseOperate': '運営',
  'hiw.phaseOperateWeeks': '継続的',
  'hiw.phaseOperateDesc': '月次レポート',
  'hiw.ctaTitle': '物件を見てみませんか？',
  'hiw.ctaDesc': '予算と目的をお聞かせください。48時間以内に厳選ショートリストをお送りします。',

  // Regions page
  'regions.sectionLabel': '日本エリアガイド',
  'regions.title': 'どこで買うか',
  'regions.intro': 'エリアごとにリスク、価格帯、賃貸需要曲線が異なります。私たちが実際に調査・リノベーション・運営したエリアのみを取り扱います。',
  'regions.activeArea': '活動エリア',
  'regions.mapLabel': 'カバレッジマップ',
  'regions.mapDesc': '現在の探査範囲は関東および周辺県です。現地調査を行っていないエリアの物件は掲載しません。',
  'regions.inventoryLabel': 'エリア別現在庫',
  'regions.properties': '物件',

  // Honesty page
  'honesty.sectionLabel': '徹底した正直さ',
  'honesty.title': '他の業者が言わないこと',
  'honesty.intro': '正直な対応で商談を失うこともあります。しかし、信頼によって長年のお客様を保つことができています。海外の非居住者として日本の不動産を購入する前に、知っておくべきすべてをここにまとめました。',
  'honesty.moreTruths': 'さらなる厳しい真実',
  'honesty.truth1Title': 'リノベーション費用は想定より高い',
  'honesty.truth1Body': '50万円の物件には300～500万円のリノベーションが必要なことが多いです。購入前に試算を提示し、トータルコストを把握してからご判断いただきます。想定外は出しません。',
  'honesty.truth2Title': '地方物件は値上がりしません',
  'honesty.truth2Body': '日本の地方人口は減少しています。安い空き家を買って値上がりを狙わないでください。収益、居住、ポートフォリオ分散の目的で購入してください。',
  'honesty.truth3Title': '税金は回避できません',
  'honesty.truth3Body': '固定資産税、賃貸収入に対する所得税、短期滞在の消費税。年次税務申告は英語で代行します。ただし、支払い義務はあなたにあります。',
  'honesty.truth4Title': '管理は完全な不労所得ではない',
  'honesty.truth4Body': '管理会社を付けても、月次レポートの確認、大規模修繕の承認、戦略的な意思決定が必要です。私たちはできる限り手間を減らします。しかし、完全な不労所得にはなりません。',
  'honesty.disclaimerLabel': '完全な免責事項',
  'honesty.disclaimerText': '掲載の収益シミュレーション、稼働率、リノベーション見積もりは代表物件に基づく保守的な試算です。実際の収益は立地、リノベーション範囲、許認可状況、市場環境により異なります。NOREN管理物件の過去実績が将来の結果を保証するものではありません。各物件は購入前に個別モデリングされます。日本の不動産所有権は居住権やビザの取得を保証しません。海外買い主はFEFTA報告および2026年の開示要件を順守する必要があります。NOREN株式会社は日本の宅地建物取引業者です。',

  // Not found
  'notFound.title': 'ページが見つかりません',
  'notFound.desc': 'お探しのページは存在しません。',
  'notFound.backHome': 'トップページに戻る',
};

export default pages;